/* unplugin-vue-components disabled */import { render } from "./detail.vue?vue&type=template&id=1f7a2544&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "../../assets/scss/new3D_detail.scss?vue&type=style&index=0&id=1f7a2544&scoped=true&lang=scss&external"
import "./detail.vue?vue&type=style&index=1&id=1f7a2544&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f7a2544"]])

export default __exports__